import { Link } from '@shopify/hydrogen'
import { MenuItemType } from '@shopify/hydrogen/storefront-api-types'
import { kebabCase } from 'lodash'
import { useContext } from 'react'
import styles from '../../assets/scss/components/desktop-menu.module.scss'
import { EnhancedMenu } from '../../lib/menus'
import { HeaderContext } from '../header/header-provider.client'
import { useI18n } from '../i18n.client'

export const ChildMenu: React.FC<{ menu: EnhancedMenu }> = ({ menu }) => {
  const [i18n] = useI18n()
  const { activeDesktopParentMenuIndex, setActiveChildMenuItem, setIsMainNavigationOpen } = useContext(HeaderContext)

  const handleClick = () => {
    setActiveChildMenuItem(undefined)
    setIsMainNavigationOpen(false)
  }

  return (
    <div className={styles.childMenu}>
      {menu.items.map(
        ({ items }, index) =>
          index === activeDesktopParentMenuIndex &&
          items.map((item) => (
            <Link
              className={styles.menuItem}
              key={item.id}
              onClick={handleClick}
              onMouseOut={() => setActiveChildMenuItem(undefined)}
              onMouseOver={() => setActiveChildMenuItem(item)}
              to={item.to}>
              {item.type === MenuItemType.ShopPolicy || item.type === MenuItemType.Blog
                ? i18n.translate(kebabCase(item.title))
                : item.title}
            </Link>
          )),
      )}
    </div>
  )
}
